import * as Sentry from '@sentry/react';

import { isValidEnvVar } from '@src/corelib/utils/envUtils';

function getConfig(params) {
  const { context = {} } = params || {};
  return {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'unknown',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.tanstackRouterBrowserTracingIntegration(context.router),
    ],
    // Tracing
    tracesSampleRate: 0.1, // Capture 10% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 10% when sampling sessions where errors occur.
  };
}

function shouldInit() {
  return import.meta.env.MODE === 'production' && isValidEnvVar('VITE_SENTRY_DSN');
}

function init(params) {
  if (shouldInit()) {
    console.info(`Init | Sentry - ${Sentry.SDK_VERSION}`);
    const config = getConfig(params);
    Sentry.init(config);
  }
}

export { getConfig, init, shouldInit };
